import { dashboardsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

const isRefreshTokenExpiredResponse = (err: unknown): boolean => {
  if (!isAxiosError(err)) return false;

  const data = err.response?.data;
  const message =
    typeof data === "string" ? data : data?.message ?? data?.detail;

  return (
    typeof message === "string" && message.includes("Refresh Token is expired")
  );
};
export const getDashboards = async (
  namespace: string,
  source_id: string,
  signal?: AbortSignal,
) => {
  const url = dashboardsUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get(
      `${url}/api/v1/ns/${namespace}/sources/${source_id}/dashboards`,
      { headers, signal },
    );
    return response.data;
  } catch (err) {
    if (signal?.aborted) return;

    if (isRefreshTokenExpiredResponse(err)) {
      navigateTo(Route.TOKENS_EXPIRED_ERROR);
      return;
    }

    // Preserve existing behavior: all other errors navigate to server error.
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
    }
    navigateTo(Route.SERVER_ERROR);
  }
};
